/* Barre appli C3 (16/10/2026) — comportement de la barre d'onglets du téléphone (menu C3, variante A, validé par Benjamin).
   Chargé en defer par sections/header-mytomette.liquid, en mode « barre » seulement. Balisage : snippets/mt-barre.liquid ;
   styles : assets/mt-barre.css. Rien ne se passe au-dessus de 860 px (la barre y est masquée).
   1. Feuilles (Idées cadeaux, Souvenirs gravés, Plus) : panneaux non modaux ; le reste de la page passe en inert (pas la barre :
      on passe d'une feuille à l'autre) ; focus sur le titre, rendu à l'onglet (Échap, ×, voile) ; fermées sur pagehide / pageshow.
   2. En-tête du téléphone : se replie après 64 px de descente (html.mt-entete-replie), revient après 12 px de remontée, en haut
      de page et au bas réel ; hauteur pleine publiée une fois dans --mt-entete-h-plein (lue par --mt-entete-h, contrat).
   3. Hexagone « Personnaliser » (variante A) : il est rendu dans cet état en Liquid sur les fiches ; ce script le relie au
      PREMIER [data-mt-barre-action] de la page et reprend son data-mt-barre-libelle (Personnaliser, Finaliser, Ajouter). Au
      toucher, dans le même geste et sans délai : mt-barre:action, puis cible.click() (le sélecteur de fichier de la photo garde
      l'activation de l'utilisateur). Aucune cible après le chargement complet : il redevient « Créer » (.mt-open-config).
      Les fiches demandent une relecture par l'événement mt-barre:maj (en plus d'un observateur d'attributs).
   4. Panier : pastille et nom accessible tenus à jour sur cart:update et au retour arrière (bfcache).
   5. Clavier : filet visualViewport (html.mt-barre-clavier) en plus de html.mt-barre-champ ; --mt-vv pour la recherche.
   6. Corrections C3 (16/10) : états de la page posés en classes sur <html> (mt-barre-remplacee, mt-barre-retiree, mt-barre-champ)
      au lieu de :has() ancrés sur <html> dans mt-barre.css ; un toucher précoce sur « Personnaliser » est gardé puis rejoué ;
      le focus revient à l'onglet après le pop-up −10 % ouvert depuis une feuille.
   7. « Acheter » (16/10, demande de Benjamin) : quand la création de la fiche est complète (libellé « Acheter » de la cible),
      l'hexagone montre un sac et un toucher AJOUTE AU PANIER par le vrai bouton de la fiche ([data-mt-barre-achat] s'il existe,
      sinon la cible) ; nom accessible « Acheter — <prix> » (data-mt-barre-prix). Pendant l'ajout (data-mt-barre-occupe de la
      cible, ou 1,5 s après le toucher le temps que la fiche démarre) : « … », aria-busy, touchers ignorés ; puis retour normal.
      Atelier guidé refermé sur une création entamée (html.mta-parcours sans écriture ni feuille ouverte depuis 1,2 s, 0,25 s après
      la feuille « Elle est prête ») : la barre revient (html.mt-barre-atelier-repos), sinon rien ne restait en bas de l'écran
      (#mtpFlot est masqué en mode barre) : c'était le cas signalé par Benjamin (récapitulatif « Votre gravure », plus de menu). */
(function () {
  'use strict';
  var html = document.documentElement;
  if (window.__mtBarre || !html.classList.contains('mt-barre')) return;
  window.__mtBarre = 1;

  var tel = window.matchMedia('(max-width:860px)');
  var EN = /^en/i.test(html.getAttribute('lang') || '');
  var T = EN ? {
    creerAria: 'Create my tile: open the configurator',
    lib: { Personnaliser: 'Personalise', Finaliser: 'Finish', Ajouter: 'Add', Acheter: 'Buy' },
    aria: { Personnaliser: 'Personalise this tile', Finaliser: 'Finish this tile', Ajouter: 'Add this tile to the basket', Acheter: 'Buy this tile' },
    achat: function (prix) { return prix ? 'Buy — ' + prix : 'Buy this tile'; },
    occupe: 'Adding to your basket…',
    panier: function (n) { return n ? 'Basket, ' + n + ' item' + (n > 1 ? 's' : '') : 'Basket, empty'; }
  } : {
    creerAria: 'Créer ma tomette : ouvrir le configurateur',
    lib: { Personnaliser: 'Personnaliser', Finaliser: 'Finaliser', Ajouter: 'Ajouter', Acheter: 'Acheter' },
    aria: { Personnaliser: 'Personnaliser cette tomette', Finaliser: 'Finaliser cette tomette', Ajouter: 'Ajouter cette tomette au panier', Acheter: 'Acheter cette tomette' },
    achat: function (prix) { return prix ? 'Acheter — ' + prix : 'Acheter cette tomette'; },
    occupe: 'Ajout au panier en cours…',
    panier: function (n) { return n ? 'Panier, ' + n + ' article' + (n > 1 ? 's' : '') : 'Panier, vide'; }
  };

  var CLES = { personnaliser: 'Personnaliser', personalise: 'Personnaliser', personalize: 'Personnaliser', finaliser: 'Finaliser', finish: 'Finaliser', ajouter: 'Ajouter', add: 'Ajouter', acheter: 'Acheter', buy: 'Acheter' };
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function barre() { return document.getElementById('mtBarre'); }
  function hexa() { var b = barre(); return b ? b.querySelector('[data-mt-barre-hexa]') : null; }
  function feuille(nom) { return document.querySelector('.mt-barre-feuille[data-mt-barre-feuille="' + nom + '"]'); }
  function focaliser(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function publier(ev, d) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(ev, d || {}); } catch (e) {} }

  /* ═════════ 1. Feuilles ═════════ */
  var ouverte = null, declencheur = null, toutesChargees = false;
  function chargerImages(f) {
    if (!f) return;
    $$('img[data-mt-menu-src]', f).forEach(function (i) { i.src = i.getAttribute('data-mt-menu-src'); i.removeAttribute('data-mt-menu-src'); });
  }
  /* contrôle final C3 : à la première feuille ouverte, les vignettes des deux autres suivent (350 ms après), pour qu'on ne voie pas
     de cases vides en passant d'une feuille à l'autre (vu sur l'accueil : Idées cadeaux puis Souvenirs, vignettes de 640 px pas encore là) */
  function chargerAutres() {
    if (toutesChargees) return;
    toutesChargees = true;
    setTimeout(function () { $$('.mt-barre-feuille').forEach(chargerImages); }, 350);
  }
  /* tout <body> en inert, sauf la barre, les feuilles et le voile (nœuds [data-mt-barre-noeud]) */
  function inerte(v) {
    [].forEach.call(document.body.children, function (n) {
      if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(n.tagName) || n.hasAttribute('data-mt-barre-noeud')) return;
      if (v) { if (!n.hasAttribute('inert')) { n.setAttribute('inert', ''); n.setAttribute('data-mt-barre-inert', ''); } }
      else if (n.hasAttribute('data-mt-barre-inert')) { n.removeAttribute('inert'); n.removeAttribute('data-mt-barre-inert'); }
    });
  }
  function onglets(nom) {
    $$('[data-mt-barre-ouvre]').forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-mt-barre-ouvre') === nom)); });
  }
  function ouvrir(nom, depuis) {
    var f = feuille(nom);
    if (!f) return false;
    $$('.mt-barre-feuille').forEach(function (x) {
      var on = x === f;
      x.classList.toggle('on', on);
      if (on) x.removeAttribute('inert'); else x.setAttribute('inert', '');
    });
    chargerImages(f);
    chargerAutres();
    if (depuis) declencheur = depuis;
    ouverte = nom;
    html.classList.add('mt-barre-feuille-on');
    onglets(nom);
    inerte(true);
    var c = f.querySelector('.mt-barre-f-corps'); if (c) c.scrollTop = 0;
    focaliser(f.querySelector('.mt-barre-f-titre'));
    publier('mt_barre_feuille', { feuille: nom });
    return true;
  }
  function fermer(rendre) {
    if (!ouverte) return;
    $$('.mt-barre-feuille').forEach(function (x) { x.classList.remove('on'); x.setAttribute('inert', ''); });
    ouverte = null;
    html.classList.remove('mt-barre-feuille-on');
    onglets('');
    inerte(false);
    var d = declencheur; declencheur = null;
    if (rendre && d && document.contains(d)) focaliser(d);
  }

  /* ═════════ 3. Hexagone : l'action principale de la fiche ═════════ */
  var cible = null, resolu = false, libelle = '';
  /* pretDOM : les scripts différés des fiches (studios lieu/ciel, photo…) ont été exécutés et ont posé leurs écouteurs
     (DOMContentLoaded passé). Un clic sur la cible avant ce moment ne ferait rien. */
  var pretDOM = document.readyState === 'complete';
  /* l'action de la fiche : mt-barre:action, puis le clic de la cible, sans délai (activation utilisateur conservée) */
  function declencher(c) {
    try { document.dispatchEvent(new CustomEvent('mt-barre:action', { detail: { cible: c, libelle: libelle || 'Personnaliser' } })); } catch (er) {}
    publier('mt_barre_action', { libelle: libelle || 'Personnaliser' });
    if (libelle === 'Acheter') {
      /* « Acheter » : le vrai bouton d'ajout de la fiche (la feuille « Elle est prête » de l'atelier), sinon la cible elle-même
         (lieu, ciel, photo : leur bouton flottant ajoute au panier quand la création est prête) */
      var a = document.querySelector('[data-mt-barre-achat]');
      debutAchat();
      (a || c).click();
      return;
    }
    /* « Finaliser » depuis l'atelier refermé : la feuille « Elle est prête » arrive après le sceau (0,95 s) ; la barre s'efface
       tout de suite au lieu de rester par-dessus pendant le sceau (elle revient 1,2 s après si rien ne s'ouvre) */
    if (libelle === 'Finaliser') suspendreRepos();
    c.click();
  }
  /* ── « Acheter » en cours : « … » sur l'hexagone, touchers ignorés. La fiche signale son ajout par data-mt-barre-occupe ;
        si rien ne démarre en 1,5 s (champ refusé, message de la fiche), l'hexagone revient à son état ; filet de 120 s. ── */
  var achatT = 0, achatVu = false;
  function debutAchat() {
    achatVu = false;
    html.classList.add('mt-barre-achat-cours');
    clearTimeout(achatT);
    achatT = setTimeout(function () { if (!achatVu) finAchat(); }, 1500);
    appliquerAction();
  }
  function finAchat() {
    clearTimeout(achatT); achatT = 0; achatVu = false;
    if (!html.classList.contains('mt-barre-achat-cours')) return;
    html.classList.remove('mt-barre-achat-cours');
    appliquerAction();
  }
  /* corrections C3 : un toucher sur « Personnaliser » arrivé avant que la fiche ait marqué son bouton (garde en ligne du snippet,
     ou surHexa ci-dessous) est noté dans window.__mtBarreTouche ; il est rejoué dès que la cible est connue ET que les scripts de
     la fiche sont prêts (moins de 8 s après le toucher). Aucune cible au chargement complet : il est oublié (l'hexagone redevient
     « Créer »). Sur la photo, le sélecteur de fichier ne s'ouvre pas au rejeu (activation perdue) : le guide s'ouvre seul. */
  function oublierToucher() { window.__mtBarreTouche = 0; html.classList.remove('mt-barre-attente'); }
  function noterToucher() { window.__mtBarreTouche = Date.now(); html.classList.add('mt-barre-attente'); }
  function rejouer() {
    var t = window.__mtBarreTouche;
    if (!t || !cible || !pretDOM) return;
    oublierToucher();
    if (document.contains(cible) && Date.now() - t < 8000) declencher(cible);
  }
  function modeCreer() {
    var h = hexa();
    cible = null; libelle = '';
    oublierToucher();
    html.classList.remove('mt-barre-perso', 'mt-barre-acheter', 'mt-barre-occupe');
    if (h) { h.classList.add('mt-open-config'); h.setAttribute('aria-label', T.creerAria); h.removeAttribute('aria-busy'); }
  }
  function appliquerAction() {
    var h = hexa(); if (!h) return;
    var c = document.querySelector('[data-mt-barre-action]');
    if (!c) {
      /* avant le chargement complet, une fiche peut encore marquer son bouton : l'état « Personnaliser » rendu en Liquid est gardé */
      if (resolu || !html.classList.contains('mt-barre-perso')) modeCreer();
      cible = null;
      return;
    }
    cible = c;
    html.classList.add('mt-barre-perso');
    h.classList.remove('mt-open-config');
    /* libellé du contrat, en français ou en anglais selon la fiche : Personnaliser|Personalise, Finaliser|Finish, Ajouter|Add */
    var cle = CLES[(c.getAttribute('data-mt-barre-libelle') || '').trim().toLowerCase()] || 'Personnaliser';
    /* « Acheter » : la cible dit son ajout en cours (data-mt-barre-occupe) ; quand il s'arrête sans quitter la page (erreur,
       message de la fiche), l'hexagone revient à l'état que la fiche donne */
    var occCible = c.hasAttribute('data-mt-barre-occupe');
    if (occCible) { achatVu = true; clearTimeout(achatT); achatT = setTimeout(finAchat, 120000); }
    else if (achatVu) { achatVu = false; clearTimeout(achatT); achatT = 0; html.classList.remove('mt-barre-achat-cours'); }
    var occupe = occCible || html.classList.contains('mt-barre-achat-cours');
    libelle = cle;
    /* le sac reste pendant l'ajout, même si la fiche referme son atelier entre-temps (son libellé repasse à « Personnaliser ») */
    html.classList.toggle('mt-barre-acheter', cle === 'Acheter' || (occupe && html.classList.contains('mt-barre-acheter')));
    html.classList.toggle('mt-barre-occupe', occupe);
    var lp = h.querySelector('.mt-barre-lib-perso'), txt = occupe ? '…' : T.lib[cle];
    if (lp && lp.textContent !== txt) lp.textContent = txt;
    var aria = occupe ? T.occupe : cle === 'Acheter' ? T.achat((c.getAttribute('data-mt-barre-prix') || '').trim()) : T.aria[cle];
    if (h.getAttribute('aria-label') !== aria) h.setAttribute('aria-label', aria);
    if (occupe) h.setAttribute('aria-busy', 'true'); else h.removeAttribute('aria-busy');
    if (window.__mtBarreTouche) rejouer();
  }
  var rafAction = 0;
  function relire() { if (!rafAction) rafAction = requestAnimationFrame(function () { rafAction = 0; appliquerAction(); }); }
  function surHexa(e) {
    var c = cible && document.contains(cible) ? cible : document.querySelector('[data-mt-barre-action]');
    if (ouverte) fermer(false);                      /* inert retiré AVANT que la suite (configurateur, atelier) ne s'ouvre */
    if (html.classList.contains('mt-barre-perso') && ((!c && !resolu) || (c && !pretDOM))) {
      /* assemblage C3 : fiche encore en chargement (mt-barre-fiche.js, async, n'a pas encore marqué #mtpFlot) : un toucher
         trop tôt ne doit pas ouvrir le configurateur à la place de l'atelier ; corrections C3 : il est gardé et rejoué, comme un
         toucher arrivé avant que les scripts différés de la fiche n'aient posé leurs écouteurs */
      e.preventDefault();
      e.stopPropagation();
      noterToucher();
      return;
    }
    if (!c) {
      /* pas d'action produit : l'hexagone est « Créer » ; le clic continue vers les écouteurs .mt-open-config du thème */
      if (html.classList.contains('mt-barre-perso')) modeCreer();
      publier('mt_barre_creer');
      return;
    }
    /* même geste, sans délai : rien n'est différé (activation utilisateur conservée pour le sélecteur de fichier) */
    e.preventDefault();
    e.stopPropagation();
    oublierToucher();
    if (html.classList.contains('mt-barre-occupe')) return;   /* « Acheter » en cours : un second toucher n'ajoute rien */
    declencher(c);
  }

  /* ═════════ Écouteurs de clic : capture sur window, donc AVANT ceux du thème posés sur document (dont la fenêtre « mode de
     création » de l'accueil, .mtmc, qui intercepte .mt-open-config en capture et arrête l'événement) : une feuille ouverte est
     refermée, et son inert retiré, avant que la surimpression demandée ne s'ouvre. ═════════ */
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var hx = t.closest('#mtBarre [data-mt-barre-hexa]');
    if (hx) { surHexa(e); return; }
    var o = t.closest('[data-mt-barre-ouvre]');
    if (o) {
      if (!tel.matches) return;
      e.preventDefault();
      var nom = o.getAttribute('data-mt-barre-ouvre');
      if (ouverte === nom) fermer(true); else ouvrir(nom, o);
      return;
    }
    if (t.closest('[data-mt-barre-fermer]')) { e.preventDefault(); fermer(true); return; }
    /* depuis une feuille : recherche, pop-up −10 %, configurateur — la feuille se ferme d'abord (la surimpression n'est pas inert) */
    if (ouverte && t.closest('[data-mts-ouvrir],[data-mtnl-open],.mt-open-config,[data-musee-open]')) {
      var onglet = declencheur;
      fermer(false);
      if (onglet && t.closest('[data-mtnl-open]')) rendreApresPopup(onglet);
    }
  }, true);
  /* corrections C3 : le pop-up −10 % rend le focus à son déclencheur, le bouton de la feuille, devenu inert donc non focalisable :
     le focus tombait sur <body>. À sa fermeture, s'il est perdu, il revient à l'onglet « Idées cadeaux ». */
  function rendreApresPopup(onglet) {
    setTimeout(function () {
      var d = document.querySelector('dialog[id^="mtnl-dialog-"]');
      if (!d || !d.open) return;
      d.addEventListener('close', function () {
        setTimeout(function () {
          etatPage();                                   /* barre de nouveau visible tout de suite : un onglet masqué refuse le focus */
          var a = document.activeElement;
          /* perdu : sur <body>, dans un nœud inert, ou sur un élément qui n'est plus affiché (WebKit le laisse dans le dialog fermé) */
          var perdu = !a || a === document.body || (a.closest && a.closest('[inert]')) || !a.getClientRects().length;
          if (perdu && document.contains(onglet)) focaliser(onglet);
        }, 0);
      }, { once: true });
    }, 0);
  }
  /* images d'une feuille préchargées dès que le doigt se pose sur son onglet */
  document.addEventListener('pointerdown', function (e) {
    var o = e.target && e.target.closest ? e.target.closest('[data-mt-barre-ouvre]') : null;
    if (o) chargerImages(feuille(o.getAttribute('data-mt-barre-ouvre')));
  }, { capture: true, passive: true });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && ouverte) { e.preventDefault(); fermer(true); }
  });
  /* retour arrière de Safari (bfcache) : jamais une feuille restée ouverte avec la page bloquée */
  window.addEventListener('pagehide', function () { fermer(false); });

  /* ═════════ 2. En-tête qui se replie quand on lit ═════════ */
  var section = document.querySelector('.mt-site-header-section'), enteteH = 0;
  function poserEntete() {
    if (!section || !tel.matches) return;
    var h = section.offsetHeight;                     /* offsetHeight ignore le transform : mesure stable, même replié */
    if (h > 0 && h !== enteteH) { enteteH = h; html.style.setProperty('--mt-entete-h-plein', h + 'px'); }   /* une écriture sur <html> : rare */
  }
  var replie = false, lastY = Math.max(0, window.scrollY || 0), acc = 0, rafDef = 0;
  function replier(v) { if (replie === v) return; replie = v; html.classList.toggle('mt-entete-replie', v); }
  function surDefilement() {
    rafDef = 0;
    if (!tel.matches) { replier(false); return; }
    if (ouverte) return;
    var y = Math.max(0, window.scrollY || 0), dy = y - lastY;
    lastY = y;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (y < 80 || y >= max - 2) { acc = 0; replier(false); return; }   /* haut de page, et bas réel */
    if (dy > 0) { acc = acc > 0 ? acc + dy : dy; if (acc >= 64) replier(true); }
    else if (dy < 0) { acc = acc < 0 ? acc + dy : dy; if (acc <= -12) replier(false); }
  }
  /* corrections C3 : téléphone couché ou très petit Safari (≤ 500 px de haut) : sur l'accueil, tant que le héros descend plus bas
     que le haut de la barre, la barre attend (html.mt-barre-heros) : son bouton et ses onglets ne passent plus dessous. */
  var heros = document.querySelector('[data-home-reel]'), court = window.matchMedia('(max-height:500px)');
  function surHeros() {
    if (!heros) return;
    var v = false;
    if (tel.matches && court.matches) {
      var b = heros.getBoundingClientRect(), n = barre(), bh = n ? n.offsetHeight : 60;
      v = b.top < window.innerHeight && b.bottom > window.innerHeight - bh;
    }
    html.classList.toggle('mt-barre-heros', v);
  }
  window.addEventListener('scroll', function () { if (!rafDef) rafDef = requestAnimationFrame(function () { surHeros(); surDefilement(); }); }, { passive: true });
  if (heros) { window.addEventListener('resize', function () { requestAnimationFrame(surHeros); }, { passive: true }); surHeros(); }

  /* ═════════ 4. Panier ═════════ */
  function majPanier(n) {
    var a = document.querySelector('#mtBarre .mt-barre-onglet-panier');
    if (!a || typeof n !== 'number' || n < 0) return;
    a.setAttribute('aria-label', T.panier(n));
    var b = a.querySelector('.mt-barre-n');
    if (n > 0) {
      if (!b) {
        b = document.createElement('b'); b.className = 'mt-barre-n'; b.setAttribute('aria-hidden', 'true');
        var ic = a.querySelector('svg'); if (ic) ic.insertAdjacentElement('afterend', b); else a.appendChild(b);
      }
      b.textContent = n > 99 ? '99+' : String(n);
    } else if (b) b.parentNode.removeChild(b);
  }
  function lirePanier() {
    var u = window.MT_CONFIG_I18N && typeof MT_CONFIG_I18N.url === 'function' ? MT_CONFIG_I18N.url('/cart.js')
      : ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart.js';
    if (!window.fetch) return;
    fetch(u, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) majPanier(d.item_count | 0); })
      .catch(function () {});
  }
  ['cart:update', 'cart:updated'].forEach(function (nom) {
    document.addEventListener(nom, function (e) {
      var d = (e && e.detail) || {}, n = null;
      if (d.resource && typeof d.resource.item_count === 'number') n = d.resource.item_count;
      else if (d.cart && typeof d.cart.item_count === 'number') n = d.cart.item_count;
      else if (d.data && typeof d.data.itemCount === 'number') n = d.data.itemCount;
      if (n !== null) majPanier(n); else lirePanier();
    });
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fermer(false); replier(false); acc = 0; lastY = Math.max(0, window.scrollY || 0);
    achatVu = false; clearTimeout(achatT); achatT = 0; html.classList.remove('mt-barre-achat-cours');
    lirePanier(); appliquerAction();
  });

  /* ═════════ 5. Clavier (filet visualViewport) et hauteur visible pour la recherche ═════════ */
  /* corrections C3 : --mt-vv n'est plus écrit sur <html> à chaque mouvement de la zone visible (barre de Safari, clavier, zoom :
     tout le document était recalculé) ; il est posé sur le seul panneau de recherche (#mtsOv), quand il est ouvert. */
  var vv = window.visualViewport, vvPose = '';
  function majVV() {
    if (!vv) return;
    var h = vv.height;
    html.classList.toggle('mt-barre-clavier', tel.matches && vv.scale < 1.05 && h < window.innerHeight - 150);
    var ov = document.getElementById('mtsOv');
    if (ov && ov.classList.contains('on')) {
      var v = Math.round(h) + 'px';
      if (v !== vvPose || ov.style.getPropertyValue('--mt-vv') !== v) { vvPose = v; ov.style.setProperty('--mt-vv', v); }
    } else vvPose = '';
  }
  if (vv) { vv.addEventListener('resize', majVV); majVV(); }

  /* ═════════ 6. États de la page, en classes sur <html> (corrections C3) ═════════
     Ils remplacent les :has() ancrés sur <html> de mt-barre.css (chacun faisait recalculer les styles de TOUT le document à chaque
     changement de classe ou d'attribut, même loin de la barre) :
     · mt-barre-remplacee : un occupant du bas visible ([data-mt-barre-remplace]:not([hidden]) : panier plein, barre d'achat R/N) ;
     · mt-barre-retiree   : une surimpression ouverte (dialog[open], configurateur, fenêtre « mode de création », atelier, recherche…) ;
     · mt-barre-champ     : un champ de saisie a le focus (clavier probable).
     Recalcul à la frame suivante, seulement quand une mutation touche un élément surveillé, et au focus. classList.toggle(c, v)
     n'écrit rien quand l'état ne change pas. */
  var SEL_REMPLACE = '[data-mt-barre-remplace]:not([hidden])';
  var SEL_SURIMP = 'dialog[open],.musee-config.is-open,.mt-cfg.is-open,.mtmc.is-open,.mtp-open,.mt-volet.mt-open,.mta-brume.mta-on,.mta-ecrit.mta-on,.mta-feuille.mta-on,.mts-ov.on';
  var SEL_SURV = 'dialog,.musee-config,.mt-cfg,.mtmc,.mtp-open,.mt-volet,.mta-brume,.mta-ecrit,.mta-feuille,.mta-motifs,.mts-ov,[data-mt-barre-remplace]';
  /* Acheter (16/10) : atelier guidé entamé mais refermé. html.mta-parcours reste posé tant que la création existe (récapitulatif
     « Votre gravure » sous la tomette) : la barre, retirée pendant tout le parcours, ne revenait plus, et #mtpFlot (« Finaliser »)
     est masqué en mode barre. Quand rien de l'atelier n'est ouvert (écriture, motif, feuille « Elle est prête », brume) depuis
     1,2 s, html.mt-barre-atelier-repos rend la barre ; le délai couvre le sceau de 0,95 s entre « Terminer » et la feuille.
     Feuille « Elle est prête » refermée (✕) : aucun sceau ne suit, la barre revient après 0,25 s. « Finaliser ma tomette → »
     touché dans la page (ou « Finaliser » de l'hexagone) : la barre s'efface tout de suite, le sceau puis la feuille arrivent. */
  var SEL_ATELIER = '.mta-ecrit.mta-on,.mta-motifs.mta-on,.mta-feuille.mta-on,.mta-brume.mta-on';
  var reposT = 0, sortieFeuille = false;
  function majAtelier() {
    var ouvert = document.querySelector(SEL_ATELIER);
    var repos = html.classList.contains('mta-parcours') && !ouvert;
    if (!repos) {
      sortieFeuille = !!document.querySelector('.mta-feuille.mta-on');
      clearTimeout(reposT); reposT = 0; html.classList.remove('mt-barre-atelier-repos'); return;
    }
    if (reposT || html.classList.contains('mt-barre-atelier-repos')) return;
    var delai = sortieFeuille ? 250 : 1200;
    sortieFeuille = false;
    reposT = setTimeout(function () {
      reposT = 0;
      if (html.classList.contains('mta-parcours') && !document.querySelector(SEL_ATELIER)) html.classList.add('mt-barre-atelier-repos');
    }, delai);
  }
  function suspendreRepos() {
    sortieFeuille = false;
    clearTimeout(reposT); reposT = 0;
    if (html.classList.contains('mt-barre-atelier-repos')) { html.classList.remove('mt-barre-atelier-repos'); planEtat(); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.mta-recap-fin') : null;
    if (t && html.classList.contains('mt-barre-atelier-repos')) suspendreRepos();
  }, true);
  var SEL_CHAMP = 'input:not([type=checkbox]):not([type=radio]):not([type=range]):not([type=file]):not([type=button]):not([type=submit]):not([type=reset]):not([type=image]):not([type=color]):not([type=hidden]),textarea,select,[contenteditable="true"],[contenteditable=""]';
  var rafEtat = 0;
  function etatPage() {
    rafEtat = 0;
    html.classList.toggle('mt-barre-remplacee', !!document.querySelector(SEL_REMPLACE));
    html.classList.toggle('mt-barre-retiree', !!document.querySelector(SEL_SURIMP));
    var a = document.activeElement, champ = false;
    try { champ = !!(a && a !== document.body && a.matches && a.matches(SEL_CHAMP)); } catch (e) {}
    html.classList.toggle('mt-barre-champ', champ);
    majAtelier();
    majVV();
  }
  function planEtat() { if (!rafEtat) rafEtat = requestAnimationFrame(etatPage); }
  function surveille(n) {
    if (!n || n.nodeType !== 1) return false;
    try { return n.matches(SEL_SURV) || !!n.querySelector(SEL_SURV); } catch (e) { return true; }
  }
  function utile(m) {
    var i;
    if (m.type === 'childList') {
      for (i = 0; i < m.addedNodes.length; i++) if (surveille(m.addedNodes[i])) return true;
      for (i = 0; i < m.removedNodes.length; i++) if (surveille(m.removedNodes[i])) return true;
      return false;
    }
    if (m.attributeName === 'class' && (m.oldValue || '').indexOf('mtp-open') >= 0) return true;   /* .mtp-open retirée */
    try { return m.target.matches(SEL_SURV); } catch (e) { return true; }
  }
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (liste) {
      if (rafEtat) return;
      for (var k = 0; k < liste.length; k++) if (utile(liste[k])) { planEtat(); return; }
    }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'hidden'], attributeOldValue: true });
  }
  /* html.mta-parcours est posée sur <html>, hors de l'observateur de <body> : on ne suit que son arrivée et son départ */
  var enParcours = html.classList.contains('mta-parcours');
  if (window.MutationObserver) new MutationObserver(function () {
    var p = html.classList.contains('mta-parcours');
    if (p !== enParcours) { enParcours = p; planEtat(); }
  }).observe(html, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('focusin', planEtat, true);
  document.addEventListener('focusout', planEtat, true);
  etatPage();

  /* ═════════ Largeur, éditeur de thème, démarrage ═════════ */
  var largeur = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth;
    poserEntete();
    if (!tel.matches) { fermer(false); replier(false); }
  }, { passive: true });
  document.addEventListener('mt-barre:maj', relire);
  document.addEventListener('shopify:section:load', function () { ouverte = null; html.classList.remove('mt-barre-feuille-on'); inerte(false); section = document.querySelector('.mt-site-header-section'); poserEntete(); relire(); });

  /* l'hexagone suit les attributs du contrat (posés ou changés par les fiches) */
  if (window.MutationObserver && document.body) {
    var surFiche = html.classList.contains('mt-barre-perso');
    new MutationObserver(relire).observe(document.body, {
      subtree: true, attributes: true, attributeFilter: ['data-mt-barre-action', 'data-mt-barre-libelle', 'data-mt-barre-prix', 'data-mt-barre-occupe'], childList: surFiche
    });
  }
  poserEntete();
  appliquerAction();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', appliquerAction);
  /* après TOUS les écouteurs de DOMContentLoaded (setTimeout 0) : les fiches sont prêtes, un toucher précoce peut être rejoué */
  if (!pretDOM) document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { pretDOM = true; appliquerAction(); }, 0); });
  function finir() { resolu = true; pretDOM = true; appliquerAction(); poserEntete(); }
  if (document.readyState === 'complete') finir(); else window.addEventListener('load', finir);

  window.mtBarre = {
    ouvrir: function (nom) { return ouvrir(nom, document.activeElement); },
    fermer: function () { fermer(true); },
    maj: appliquerAction,
    etat: function () { return { feuille: ouverte, replie: replie, perso: html.classList.contains('mt-barre-perso'), cible: cible, libelle: libelle }; }
  };
  window.__mtBarrePret = true;
})();
